






































































































import Component from "vue-class-component";
import { Vue } from "vue-property-decorator";

@Component({})
class LoginDialog extends Vue {
  // #################### INIT ###################

  /**
   * Boolean indicating whether there was an error during the login
   */
  loginError: boolean = false;

  /**
   * Username inserted by the user
   */
  loginUsername: string = "";

  /**
   * Password inserted by the user
   */
  loginPassword: string = "";

  // #################### Methods #############################

  /**
   * Get the title of the login dialog, based on the user's status
   */
  pageTitle() {
    if (this.isGuest) {
      return "LOGIN GIORGIO VALMASSOI SARTORIALE";
    } else {
      return (
        "GIORGIO VALMASSOI SARTORIALE - ACCOUNT " +
        this.$store.state.configurator.user.user.username
      );
    }
  }

  /**
   * Verify the login credentials, and if they are correct, log the user in
   */
  async verifyLoginCredentials() {
    let loginResp = await this.$store.dispatch("configurator/user/login", {
      username: this.loginUsername,
      password: this.loginPassword,
    });
    if (Object.entries(loginResp.data).toString().includes("error,true")) {
      this.loginError = true;
    } else {
      // Logged
      this.loginError = false;
    }
  }

  /**
   * Logout the user
   */
  logout() {
    this.loginUsername = "";
    this.loginPassword = "";
    this.$store.dispatch("configurator/user/logout");
  }

  // #################### Watchers ###########################
  // #################### Getters/Setters ############################
  
  /**
   * Check whether the user is logged in or not
   */
  public get isGuest(): boolean {
    return this.$store.getters["configurator/user/isGuest"];
  }
}
export default LoginDialog;
